var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('PageHeaderLayout',[_c('div',{staticClass:"main-page-content"},[_c('h3',[_vm._v("排班管理")])])])}
var staticRenderFns = []

export { render, staticRenderFns }